<template>
  <div style="height: 100vh; display: flex; flex-direction: column;">
    <div
      style="
        background-color: #fff;
        box-shadow: 1px 1px 15px rgb(0 0 0 / 10%);
        height: 60px;
        line-height: 60px;
        padding: 0 20px 0 40px;
        position: relative;
        z-index: 999;
        left: 0;
        right: 0;
      "
    >
      <div class="goBack" @click="goToBack()"><i class="el-icon-back"></i></div>
      <el-row type="flex" justify="center" align="center">
        <el-col :xs="24">
          <div class="headerMain">
            <div style="display: flex">
              <img
                src="@/assets/img/logo.jpg"
                alt="logo"
                style="width: 60px; height: 60px"
              />
              <div class="headerTop">视频监控页面</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="flex: 1; display: flex; overflow: hidden;">
      <!-- 左侧回放区域 -->
      <div class="left-section">
        <div class="section-header">
          <h3>回放视频</h3>
        </div>
        <div class="search-form">
          <el-form size="small" inline>
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="playbackStartTime"
                type="datetime"
                placeholder="选择开始时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyyMMddHHmmss"
                style="width: 200px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="playbackEndTime"
                type="datetime"
                placeholder="选择结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyyMMddHHmmss"
                style="width: 200px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="changePlaybackTime" size="small">查询</el-button>
              <el-button @click="resetPlaybackTime" size="small">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="video-container" v-if="showPlaybackPlayer">
          <div id="playbackPlayer" class="ezui-player"></div>
        </div>
      </div>

      <!-- 右侧视频播放区域 -->
      <div class="right-section">
        <div class="section-header">
          <h3>设备实时视频</h3>
          <div class="video-info">{{ currentVideoInfo }}</div>
        </div>
        <!-- 视频控制按钮，当前隐藏 -->
        <div class="video-controls" style="display: none;">
          <el-button type="primary" @click="pauseVideo" size="small">暂停</el-button>
          <el-button type="primary" @click="resumeVideo" size="small">恢复</el-button>
        </div>
        <div class="video-container">
          <div id="ezuiPlayer" class="ezui-player"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
import axios from "axios";

export default {
  name: "VideoPage",
  data: function () {
    return {
      // 视频播放器实例
      videoPlayer: null,
      // 回放播放器实例
      playbackPlayer: null,
      // 萤石云AccessToken
      accessToken: "at.6helyecf5qmpx5137jftok948ptdilev-99tuajwm4k-0tni52r-wygyzcypn",
      // 设备信息
      deviceInfo: {
        deviceSerial: "BG9380217",
        channelNo: 1,
      },
      // 回放时间
      playbackStartTime: "20260104173000",
      playbackEndTime: "20260104174000",
      // 控制播放器显示状态
      showPlaybackPlayer: false,
      // 搜索表单数据
      searchForm: {
        startDate: this.getDefaultStartTime(), // 默认当天6:00
        endDate: this.getDefaultEndTime(), // 默认当天20:00
      },
      // 视频文件列表
      videoFiles: [],
      // 加载状态
      loading: false,
      // 当前视频信息
      currentVideoInfo: "",
      // 当前播放的是直播还是回放
      isLive: true,
    };
  },

  mounted() {
    // 页面加载完成后初始化视频播放器
    this.$nextTick(() => {
      // 初始化右侧直播播放器
      this.initVideoPlayer();
      // 默认查询最近24小时的录像
      this.queryVideoFiles();
    });
  },
  
  

  methods: {
    // 统一响应处理函数
    handleResponse(response) {
      // 处理不同的响应格式
      let code, message;
      
      // 格式1: { meta: { code: 200, message: "成功" }, data: {} }
      if (response.data.meta) {
        code = response.data.meta.code;
        message = response.data.meta.message;
      } 
      // 格式2: { code: "200", msg: "成功", data: {} }
      else {
        code = response.data.code;
        message = response.data.msg;
      }
      
      // 统一比较逻辑，将code转换为字符串进行比较
      if (String(code) !== "200") {
        this.$message.error(message || "操作失败");
        return false;
      }
      
      return true;
    },
    
    goToBack() {
      this.$router.go(-1);
    },

    // 获取默认开始时间：2026-01-05 9:20
    getDefaultStartTime() {
      const date = new Date(2026, 0, 5, 9, 20, 0, 0);
      return date.getTime();
    },

    // 获取默认结束时间：2026-01-05 10:00
    getDefaultEndTime() {
      const date = new Date(2026, 0, 5, 10, 0, 0, 0);
      return date.getTime();
    },

    // 初始化右侧直播播放器
    initVideoPlayer(url = null) {
      // 销毁已存在的播放器实例
      this.destroyVideoPlayer();

      // 使用导入的EZUIKit初始化播放器
      this.videoPlayer = new EZUIKit.EZUIKitPlayer({
        id: "ezuiPlayer",
        accessToken: this.accessToken,
        url: url || "ezopen://open.ys7.com/BG9380217/1.hd.live",
        
        width: "100%",
        height: "100%",
        autoplay: true,
        audio: 0,
        openSoundCallBack: function () {},
        closeSoundCallBack: function () {},
        // EZUIKit正确的控制栏配置
        template: 'standard', // 使用标准模板，包含完整控制栏
        plugin: ['fullScreen'], // 启用全屏插件
      });

      console.log("直播播放器初始化完成");
    },
    
    // 初始化左侧回放播放器
    initPlaybackPlayer() {
      // 销毁已存在的播放器实例
      this.destroyPlaybackPlayer();
      
      // 构建完整的回放URL，包含开始时间和结束时间
      const playbackUrl = `ezopen://open.ys7.com/${this.deviceInfo.deviceSerial}/${this.deviceInfo.channelNo}.rec?begin=${this.playbackStartTime}&end=${this.playbackEndTime}`;
      
      // 使用导入的EZUIKit初始化播放器
      this.playbackPlayer = new EZUIKit.EZUIKitPlayer({
        id: "playbackPlayer",
        accessToken: this.accessToken,
        url: playbackUrl,
        
        width: "100%",
        height: "100%",
        autoplay: true,
        audio: 0,
        openSoundCallBack: function () {},
        closeSoundCallBack: function () {},
        // EZUIKit回放模板配置
        template: 'pcRec', // 使用回放模板
        plugin: ['fullScreen'], // 启用全屏插件
      });
      
      console.log("回放播放器初始化完成");
    },
    
    // 切换回放时间
    changePlaybackTime() {
      // 显示播放器
      this.showPlaybackPlayer = true;
      
      // 确保DOM已更新
      this.$nextTick(() => {
        // 如果播放器未初始化，则初始化
        if (!this.playbackPlayer) {
          this.initPlaybackPlayer();
        } else {
          // 如果播放器已初始化，则切换播放时间
          const playbackUrl = `ezopen://open.ys7.com/${this.deviceInfo.deviceSerial}/${this.deviceInfo.channelNo}.rec?begin=${this.playbackStartTime}&end=${this.playbackEndTime}`;
          this.playbackPlayer.changePlayUrl({url: playbackUrl});
          console.log("切换回放时间:", playbackUrl);
          
          // 切换URL后尝试恢复播放，确保视频自动开始播放
          this.$nextTick(() => {
            if (this.playbackPlayer && this.playbackPlayer.resume) {
              this.playbackPlayer.resume();
              console.log("回放视频已开始播放");
            }
          });
        }
      });
    },
    
    // 重置回放时间
    resetPlaybackTime() {
      // 设置默认的开始时间和结束时间
      this.playbackStartTime = "20260104173000";
      this.playbackEndTime = "20260104174000";
      console.log("回放时间已重置为默认值");
    },

    // 查询视频文件
    async queryVideoFiles() {
      try {
        this.loading = true;
        this.videoFiles = [];

        // 参数验证
        if (!this.searchForm.startDate || !this.searchForm.endDate) {
          this.$message.error("请选择开始时间和结束时间");
          return;
        }

        if (this.searchForm.startDate >= this.searchForm.endDate) {
          this.$message.error("结束时间必须大于开始时间");
          return;
        }

        // 构建请求参数，将毫秒级时间戳转换为秒级时间戳字符串
        const params = {
          deviceSerial: this.deviceInfo.deviceSerial,
          localIndex: this.deviceInfo.channelNo.toString(),
          startTime: Math.floor(this.searchForm.startDate / 1000).toString(),
          endTime: Math.floor(this.searchForm.endDate / 1000).toString(),
          pageSize: this.pageSize,
          pageNo: this.currentPage,
        //   recordType: 1, // 1:定时录像 2:事件录像 3:智能-车 4:智能-人形 5:自动浓缩录像，不填默认查询所有类型
        };

        // 萤石云文档 https://open.ys7.com/help/3922

        // 调用统一查询本地录像文件接口
        const response = await axios.get("https://open.ys7.com/api/v3/device/local/video/unify/query", {
          headers: {
            'deviceSerial': this.deviceInfo.deviceSerial, // 将deviceSerial参数也放到Header里面
            'accessToken': this.accessToken // 将accessToken参数也放到Header里面
          },
          params: params // GET请求参数放在params中，会自动转换为URL查询字符串
        });

        if (this.handleResponse(response)) {
          const records = response.data.data.records || [];
          // 转换数据格式，适配原有列表展示
          this.videoFiles = records.map(item => ({
            id: `${item.startTime}_${item.endTime}`, // 生成唯一ID
            name: `录像_${new Date(item.startTime * 1000).toLocaleString()}`, // 生成文件名
            startTime: item.startTime * 1000, // 转换为毫秒级时间戳
            endTime: item.endTime * 1000, // 转换为毫秒级时间戳
            fileSize: item.size, // 文件大小
            type: item.type // 录像类型
          }));
          
          // 设置总分页信息
          this.total = response.data.data.total || 0;
          
          if (this.videoFiles.length === 0) {
            this.$message.info("未找到符合条件的录像文件");
          }
        }
      } catch (error) {
        console.error("查询视频文件失败:", error);
        this.$message.error("查询视频文件失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 处理视频文件点击
    async handleVideoFileClick(file) {
      try {
        this.isLive = false;
        this.currentVideoInfo = `正在播放录像: ${file.name}`;

        // 获取回放URL
        const playbackUrl = await this.getPlaybackUrl(file.startTime, file.endTime);
        if (playbackUrl) {
          // 初始化播放器播放回放
          this.initVideoPlayer(playbackUrl);
        }
      } catch (error) {
        console.error("播放视频失败:", error);
        this.$message.error("播放视频失败，请重试");
      }
    },

    // 获取设备回放RTMP地址
    async getPlaybackUrl(startTime, endTime) {
      try {
        // 构建请求参数
        const params = {
          accessToken: this.accessToken,
          deviceSerial: this.deviceInfo.deviceSerial,
          channelNo: this.deviceInfo.channelNo,
          startTime: startTime,
          endTime: endTime,
          streamType: 1, // 默认1:主码流
        };

        // 调用获取设备回放RTMP地址接口
        const response = await axios.post("https://open.ys7.com/api/lapp/v2/live/address/get", params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          transformRequest: [function (data) {
            // 将参数转换为x-www-form-urlencoded格式
            let ret = ''
            for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret.slice(0, -1)
          }]
        });

        if (this.handleResponse(response)) {
          return response.data.data.url;
        } else {
          return null;
        }
      } catch (error) {
        console.error("获取回放地址失败:", error);
        this.$message.error("获取回放地址失败，请重试");
        return null;
      }
    },

    // 切换到直播
    switchToLive() {
      this.isLive = true;
      this.currentVideoInfo = "正在播放直播";
      // 初始化播放器播放直播
      this.initVideoPlayer();
    },

    // 暂停视频
    pauseVideo() {
      if (this.videoPlayer && this.videoPlayer.pause) {
        this.videoPlayer.pause();
        console.log("视频已暂停");
      }
    },

    // 恢复视频
    resumeVideo() {
      if (this.videoPlayer && this.videoPlayer.resume) {
        this.videoPlayer.resume();
        console.log("视频已恢复播放");
      }
    },

    // 销毁右侧直播播放器
    destroyVideoPlayer() {
      if (this.videoPlayer) {
        this.videoPlayer.destroy();
        this.videoPlayer = null;
        console.log("直播播放器已销毁");
      }
    },
    
    // 销毁左侧回放播放器
    destroyPlaybackPlayer() {
      if (this.playbackPlayer) {
        this.playbackPlayer.destroy();
        this.playbackPlayer = null;
        console.log("回放播放器已销毁");
      }
    },

    // 格式化时间
    formatTime(row, column, cellValue) {
      if (!cellValue) return "";
      return new Date(cellValue).toLocaleString();
    },

    // 格式化文件大小
    formatFileSize(row, column, cellValue) {
      if (!cellValue) return "";
      if (cellValue < 1024) {
        return cellValue + " B";
      } else if (cellValue < 1024 * 1024) {
        return (cellValue / 1024).toFixed(2) + " KB";
      } else if (cellValue < 1024 * 1024 * 1024) {
        return (cellValue / (1024 * 1024)).toFixed(2) + " MB";
      } else {
        return (cellValue / (1024 * 1024 * 1024)).toFixed(2) + " GB";
      }
    },
  },

  // 组件销毁时销毁两个播放器实例
  beforeDestroy() {
    this.destroyVideoPlayer();
    this.destroyPlaybackPlayer();
  },
};
</script>

<style lang="scss">
.headerMain {
  .el-icon-setting {
    color: #606266;
  }

  .el-icon-setting:hover {
    color: rgb(64, 158, 255);
  }
}

/* 主容器样式 */
.main-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 左右分栏布局 */
.left-section {
  width: 50%;
  height: 100%;
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.right-section {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

/* 区域标题样式 */
.section-header {
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
  }
}

/* 搜索表单样式 */
.search-form {
  padding: 8px 12px;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
}

/* 调整表单项样式 */
.search-form .el-form {
  width: 100%;
}

.search-form .el-form-item {
  margin-bottom: 0 !important;
  margin-right: 12px;
}

/* 调整日期选择器宽度 */
.search-form .el-date-picker {
  width: 280px !important;
  margin-right: 8px;
}

/* 调整按钮样式 */
.search-form .el-button {
  margin-left: 8px;
}

/* 视频列表容器样式 */
.video-list-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 8px;
}

/* 表格滚动容器 */
.table-scroll-container {
  flex: 1;
  margin-bottom: 10px;
}

/* 表头悬浮样式 */
.video-list-container .el-table th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

/* 确保表格内容区域滚动时表头固定 */
.video-list-container .el-table {
  margin-bottom: 0;
}

/* 分页容器样式 */
.pagination-container {
  margin-top: 0;
  padding: 10px 0;
  background-color: #fff;
  border-top: 1px solid #e4e7ed;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

/* 视频容器样式 */
.video-container {
  flex: 1;
  background-color: #000;
  overflow: hidden;
  position: relative;

  .ezui-player {
    width: 100%;
    height: 100%;
  }
}

/* 视频控制栏样式 */
.video-controls {
  padding: 12px;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  align-items: center;
}

/* 视频信息样式 */
.video-info {
  font-size: 12px;
  color: #606266;
  margin-left: 12px;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .left-section {
    width: 50%;
  }
  
  .right-section {
    width: 50%;
  }
}

@media (max-width: 992px) {
  .left-section {
    width: 55%;
  }
  
  .right-section {
    width: 45%;
  }
  
  .search-form {
    padding: 8px;
  }
  
  .el-form-item {
    margin-bottom: 8px !important;
  }
}

@media (max-width: 768px) {
  .left-section {
    width: 100%;
    height: 50%;
  }
  
  .right-section {
    width: 100%;
    height: 50%;
  }
  
  .left-section, .right-section {
    border: none;
  }
  
  .left-section {
    border-bottom: 1px solid #e4e7ed;
  }
  
  .right-section {
    border-top: 1px solid #e4e7ed;
  }
}
</style>